import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_2 = { key: 0 }

import TranslatedState from '@/components/common/TranslatedState.vue';
import InitiativeShortForm from '@/components/initiative/InitiativeShortForm.vue';
import { Initiative, getShortStatus } from '@/models/initiative.model';
import { useEvents, Event as EventType } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { computed, markRaw, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativeListView',
  setup(__props) {

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();
const { t } = useI18n();
const router = useRouter();
const events = useEvents();

const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);

function addInitiative() {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(InitiativeShortForm),
  });
}

function editInitiative(_: Event, { item }: { item: Initiative }) {
  router.push(`/initiative/${item.publicUUID}/edit`);
}

const updateLanguage = async () => {
  store.dispatch(ContentStoreActions.GetInitiativesByContentEditor);
};

onMounted(() => {
  events.on(EventType.LanguageChanged, updateLanguage);
  updateLanguage();
});

onBeforeUnmount(() => {
  events.off(EventType.LanguageChanged, updateLanguage);
});

const headers = [
  {
    title: t('initiative.edit.index'),
    key: 'index',
    width: '2%',
  },
  { title: t('initiative.edit.title'), key: 'title', width: '50%' },
  { title: t('initiative.edit.category'), key: 'categories', width: '25%' },
  { title: t('initiative.edit.sharing'), key: 'options', width: '10%' },
  { title: t('initiative.edit.state'), key: 'translated', sortable: false },
];

function share(evt: Event, item: Initiative) {
  navigator.clipboard.writeText(
    `${document.location.protocol}//${document.location.host}/#/initiative/${item.publicUUID}/edit`,
  );

  store.dispatch(Actions.ShowNotification, {
    message: 'Copied to clipboard',
    type: 'success',
  });
  evt.stopPropagation();
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "mt-16" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "9" }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('initiative.list.header')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, { onClick: addInitiative }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.list.add')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: initiatives.value,
        "onClick:row": _withModifiers(editInitiative, ["prevent"]),
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_chip, {
              class: "mr-4",
              color: "primary",
              density: "compact",
              variant: "flat"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`initiative.edit.status_${_unref(getShortStatus)(item, item.status)}`)), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
            _createVNode(_component_v_tooltip, { text: "This item is recommended" }, {
              activator: _withCtx(({ props }) => [
                (!!item.recommended)
                  ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                      icon: "mdi-thumb-up-outline",
                      color: "primary",
                      class: "ml-2"
                    }), null, 16))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _cache[0] || (_cache[0] = _createTextVNode("   ")),
            _createVNode(_component_v_tooltip, {
              text: 
              item.published
                ? 'This item is published'
                : 'This item is not published'
            
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, {
                  icon: item.published ? 'mdi-eye-check' : 'mdi-eye-outline',
                  color: item.published ? 'green' : 'red'
                }), null, 16, ["icon", "color"])
              ]),
              _: 2
            }, 1032, ["text"])
          ])
        ]),
        "item.categories": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.categories && item.categories[0]
            ? item.categories[0].title
            : item.mainCategory
            ? item.mainCategory.title
            : ''), 1)
        ]),
        "item.options": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            density: "compact",
            color: "indigo-lighten-3",
            onClick: _withModifiers(($event: any) => (share($event, item)), ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.share')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        "item.title": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value) + " ", 1),
          (!value)
            ? (_openBlock(), _createElementBlock("em", _hoisted_2, "[no translation]"))
            : _createCommentVNode("", true)
        ]),
        "item.index": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1), 1)
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})